import React from 'react'
import { Box } from '@chakra-ui/react'
import { Skeleton } from '@chakra-ui/react'

export default function InfoLoadingPlaceholder() {
    return (
        <Box>
            <Skeleton height="56px" width="100%" rounded="xl" />
        </Box>
    )
}
